import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=380d3a86&"
import script from "./button-group.vue?vue&type=script&lang=js&"
export * from "./button-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports